import React, { createContext, useContext, useState, useEffect } from 'react';
import { apiService } from '../services/api';

const PromoContext = createContext(null);

export const PromoProvider = ({ children }) => {
  const [appliedPromoCode, setAppliedPromoCode] = useState(null);
  /** Размер скидки в рублях при применённом промокоде (из ответа validate) */
  const [appliedPromoDiscount, setAppliedPromoDiscount] = useState(null);
  // Промокод, доступный пользователю (действительный и не использованный) — с бэкенда
  const [activePromoCode, setActivePromoCode] = useState(null);

  const clearAppliedPromo = () => {
    setAppliedPromoCode(null);
    setAppliedPromoDiscount(null);
  };

  const setAppliedPromo = (code, discountAmount) => {
    setAppliedPromoCode(code);
    setAppliedPromoDiscount(discountAmount != null ? discountAmount : null);
  };

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const res = await apiService.getAvailablePromoCode();
      if (!cancelled && res && res.valid && res.code) {
        setActivePromoCode(res.code);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <PromoContext.Provider value={{
      appliedPromoCode,
      setAppliedPromoCode,
      appliedPromoDiscount,
      setAppliedPromoDiscount,
      clearAppliedPromo,
      setAppliedPromo,
      activePromoCode
    }}>
      {children}
    </PromoContext.Provider>
  );
};

export const usePromo = () => {
  const ctx = useContext(PromoContext);
  if (!ctx) {
    throw new Error('usePromo must be used within PromoProvider');
  }
  return ctx;
};
